import * as React from 'react';

const DimensionContext = React.createContext<boolean>(true);

export default DimensionContext;
